import classNames from 'classnames'

import { MenuItem } from '../settings-menu/menu-item'
import { BankIcon, LiquidityAssetsIcon, MoneyIcon } from './icons'

export function PlatformStats() {
    const valueStyles = classNames('font-semibold text-gray8')
    return (
        <div className='flex flex-col'>
            <h2>🌽 Masa Protocol Stats</h2>
            <ul className='mt-2'>
                <li>
                    <p>
                        Avg. APY: <span className={valueStyles}>8,55%</span>
                    </p>
                </li>
                <li>
                    <p>
                        Total Pooled Value:{' '}
                        <span className={valueStyles}>$2.63 M</span>
                    </p>
                </li>
                <li>
                    <p>
                        Total LP Tokens:{' '}
                        <span className={valueStyles}>2.64 M</span>
                    </p>
                </li>
                <li>
                    <p>
                        Total Insurance Fund:{' '}
                        <span className={valueStyles}>$50 K</span>
                    </p>
                </li>
            </ul>

            <div className='grid grid-rows-list gap-6 mt-4'>
                <MenuItem
                    icon={<BankIcon />}
                    title='Total Value Locked'
                    description='$2,640,568.69'
                    className='h-32'
                    active={true}
                />
                <MenuItem
                    icon={<MoneyIcon />}
                    title='Utilization'
                    description={
                        <div>
                            <span className='font-semibold'>47%</span> locked
                            <br />
                            <span className='font-semibold'>53%</span> liquid
                        </div>
                    }
                    active={true}
                />
                <MenuItem
                    icon={<LiquidityAssetsIcon />}
                    title='Liquid Assets'
                    description={
                        <span className='font-semibold'>$1,320,258.35</span>
                    }
                    active={true}
                />
                <MenuItem
                    icon={<LiquidityAssetsIcon />}
                    title='Rewards - Epoch 1'
                    description={
                        <>
                            <span className='text-success mr-1'>100,500</span> /
                            110,000,000
                        </>
                    }
                    active={true}
                />
            </div>
        </div>
    )
}
